import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pager } from '../pager/pager';
import { FilterBar } from '../filter-bar/filter-bar';
import { DateTime } from '../datetime/datetime';
import { useGetTasksQuery } from './tasks.api';
import { TaskStatus } from '@topshots/core-models';
import { Card, CardContent } from 'shared-components';
import { PageTitle } from 'shared-components';
import Routes from '../../app/routes';

export const Tasks = () => {
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [status, setStatus] = useState<TaskStatus>(TaskStatus.Complete);
  const { data, isLoading } = useGetTasksQuery({
    page,
    perPage,
    status,
  });
  const navigate = useNavigate();

  if (isLoading) {
    return <span>loading...</span>;
  }
  return (
    <>
      <PageTitle
        title="Tasks"
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.TASKS.title, link: Routes.TASKS.link },
        ]}
      />
      <Card>
        <CardContent>
          <FilterBar
            //search={false}
            value={{
              status,
            }}
            filters={[
              {
                key: 'status',
                title: 'Status',
                options: [
                  { display: 'Pending', value: TaskStatus.Pending },
                  { display: 'Error', value: TaskStatus.Error },
                  { display: 'Working', value: TaskStatus.Working },
                  { display: 'Complete', value: TaskStatus.Complete },
                ],
                //default: status,
              },
            ]}
            onFilterChanged={(filter, values) => {
              switch (filter.key) {
                case 'status':
                  setStatus(values as TaskStatus);
                  break;
              }
            }}
            // onSearch={(term) => {
            //   setSearch(term === '' ? undefined : term);
            // }}
          />
        </CardContent>
        <table>
          <thead>
            <tr>
              <th>Created</th>
              <th>Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data?.data.map((t) => (
              <tr
                onClick={() => {
                  navigate(`${t._id}`);
                }}
                key={t._id.toString()}
              >
                <td>
                  <DateTime d={t.created_on} />
                </td>
                <td>{t.type}</td>
                <td>{t.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pager
          onNext={() => {
            setPage(page + 1);
          }}
          onPrevious={() => {
            setPage(page - 1);
          }}
          onPageSelected={(selected) => {
            setPage(selected);
          }}
          onPerPageChange={(selected) => {
            setPerPage(selected);
            setPage(1);
          }}
          page={page}
          perPage={perPage}
          totalPages={data?.totalPages ?? 1}
        />
      </Card>
    </>
  );
};
